import React from 'react';
import { bool, func } from 'prop-types';

import ImageAutoOrderExpired from '@assets/Image/Trading/AutoOrder/ATO-expired.svg';

import { Container, Row, Col, Button, Typography } from '@ajaibid/components';
import { PopUpCenterV2 } from 'Component/PopUp';

const PopUpAutoOrderExpired = (props) => {
  const { show, onHide, onConfirm } = props;

  return (
    <PopUpCenterV2 size="md" show={show} onHide={onHide}>
      <img src={ImageAutoOrderExpired} alt="account-suspended" />
      <Container padding="8px 48px 32px">
        <Typography type="body" bold align="center" margin={0}>
          Aktifkan Auto Order yang sudah berakhir?
        </Typography>
        <Typography type="body" align="center" marginTop={8}>
          Kamu harus mengatur ulang syarat dan durasi Auto Order ini.
        </Typography>
      </Container>
      <Row gutters={8} align="between">
        <Col>
          <Button fluid variant="secondary" size="lg" onClick={onHide}>
            Batal
          </Button>
        </Col>
        <Col>
          <Button fluid variant="primary" size="lg" onClick={onConfirm}>
            Oke
          </Button>
        </Col>
      </Row>
    </PopUpCenterV2>
  );
};

PopUpAutoOrderExpired.propTypes = {
  show: bool,
  onHide: func,
  onConfirm: func,
};

PopUpAutoOrderExpired.defaultProps = {
  show: false,
  onHide: () => {},
  onConfirm: () => {},
};

export default PopUpAutoOrderExpired;
